import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/Tabs';
import React from 'react';
import { PhoneCapture } from './PhoneCapture';

export const AUTH_CARD_CLASS = 'bg-earth-800 rounded-lg shadow-xl w-full max-w-md';
export const AUTH_TITLE_CLASS = 'text-2xl font-brand-display text-sand-100';

export type AuthScreenTab = 'sign-in' | 'sign-up';

export function authScreenHeading(tab: AuthScreenTab): string {
  return tab === 'sign-up' ? 'Join Rendezvous' : 'Welcome Back';
}

interface AuthScreenProps {
  activeTab: AuthScreenTab;
  onTabChange: (tab: AuthScreenTab) => void;
  onVerified: () => void;
  /** Dialog title in the modal; a plain heading on the standalone page. */
  Title?: React.ElementType<{ className?: string; children?: React.ReactNode }>;
  close?: React.ReactNode;
}

/**
 * Shared sign-in screen: the modal and `/login` both render this, so the copy
 * and the card chrome stay the same.
 */
export function AuthScreen({
  activeTab,
  onTabChange,
  onVerified,
  Title = 'h1',
  close,
}: AuthScreenProps) {
  return (
    <>
      <div className="flex items-center justify-between p-6 border-b border-earth-700">
        <Title className={AUTH_TITLE_CLASS}>{authScreenHeading(activeTab)}</Title>
        {close}
      </div>
      <div className="p-6">
        <Tabs
          value={activeTab}
          className="space-y-6"
          onValueChange={(value) => {
            onTabChange(value === 'sign-up' ? 'sign-up' : 'sign-in');
          }}
        >
          <TabsList className="w-full">
            <TabsTrigger
              value="sign-in"
              className="flex-1 data-[state=active]:bg-sand-200 data-[state=active]:text-earth-900"
            >
              Login
            </TabsTrigger>
            <TabsTrigger
              value="sign-up"
              className="flex-1 data-[state=active]:bg-sand-200 data-[state=active]:text-earth-900"
            >
              Join
            </TabsTrigger>
          </TabsList>

          <TabsContent value="sign-in">
            <div className="space-y-6">
              <PhoneCapture
                defaultChannel="sms"
                mode="login"
                onVerified={onVerified}
              />
            </div>
          </TabsContent>

          <TabsContent value="sign-up">
            <div className="space-y-4">
              <PhoneCapture
                defaultChannel="sms"
                mode="register"
                onVerified={onVerified}
              />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
}
